function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.182 0l3.836 3.924L8.93.1 10 1.194 6.087 5.018 9.913 8.93 8.819 10 4.994 6.088 1.07 9.925 0 8.831l3.924-3.837L.087 1.07 1.182 0z",
  fill: "#252525",
  fillRule: "nonzero"
});

function SvgFeatureClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFeatureClose;